<template>
  <div>
    <el-container style="position: absolute;left: 0;right: 0;bottom: 0;top: 50px;">
      <!-- 左侧菜单 -->
      <el-aside width="300px" style="background-color: rgb(238, 241, 246)">
        <div class="tab-item" :class="{active: this.$route.path==='/home/user/account'}" @click="toPath('account')">
            <span class="iconfont">&#xe63d;</span>
            <span>我的账户</span>
        </div>
        <div class="tab-item" :class="{active: this.$route.path==='/home/user/setting'}" @click="toPath('setting')">
            <span class="iconfont">&#xe781;</span>
            <span>系统设置</span>
        </div>
          <div class="tab-item" :class="{active: this.$route.path==='/home/user/myTemplate'}" @click="toPath('myTemplate')">
              <span class="iconfont">&#59251;</span>
              <span>我的模板</span>
          </div>
          <div class="tab-item" :class="{active: this.$route.path==='/home/user/templateSetting'}" @click="toPath('templateSetting')">
              <span class="iconfont">&#58909;</span>
              <span>模板设置</span>
          </div>
        <div class="tab-item" :class="{active: this.$route.path==='/home/user/opinion' || this.$route.path==='/home/user/result'}"
          @click="toPath('opinion')">
            <span class="iconfont">&#xe622;</span>
            <span>反馈意见</span>
        </div>
      </el-aside>
      <!-- 右侧内容 -->
      <el-container>
          <el-main>
          <router-view></router-view>
          </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import '../assets/iconfont/iconfont.css'
export default {
    name: "",
    methods: {
        toPath(path) {
            this.$router.replace('/home/user/' + path)
        }
    }
};
</script>

<style scoped>
    .tab-item{
        display: flex;
        align-items: center;
        height: 50px;
        color: #47a2bf;
        padding: 0 20px;
        border-bottom: 1px solid #fff;
        line-height: 50px;
        font-size: 14px;
        user-select: none;
    }
    .tab-item.active{
        background-color: #47a2bf;
        color: #fff;
    }
    .iconfont{
        font-size: 24px;
        margin-right: 20px;
    }
</style>
